import { render, staticRenderFns } from "./custom-table-component.vue?vue&type=template&id=dd861d20"
import script from "./custom-table-component.vue?vue&type=script&lang=js"
export * from "./custom-table-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd861d20')) {
      api.createRecord('dd861d20', component.options)
    } else {
      api.reload('dd861d20', component.options)
    }
    module.hot.accept("./custom-table-component.vue?vue&type=template&id=dd861d20", function () {
      api.rerender('dd861d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "custom-table-component.vue"
export default component.exports